import { ApiService } from "../../../services/ApiService";
import {
  GET_ASSETS_CAT,
  GET_ALL_ASSETS,
  GET_ALL_REQUESTS,
  GET_ALL_EXPENDITURES,
  GET_PENDING_REQUEST,
} from "../../actionTypes";

export class orgarnizationMngtThunk {
  static getAssetsCart() {
    return async (dispatch) => {
      try {
        const response = await ApiService.get("assets/asset-categories");
        if (response.data) {
          dispatch({
            type: GET_ASSETS_CAT,
            payload: response.data.asset_categories,
          });
          return;
        }
      } catch (err) {}
    };
  }

  static getAllAssets() {
    return async (dispatch) => {
      try {
        const response = await ApiService.get("assets");
        if (response.data) {
          dispatch({
            type: GET_ALL_ASSETS,
            payload: response.data,
          });
          return;
        }
      } catch (err) {}
    };
  }

  static getAllRequest(query = "?page=1") {
    return async (dispatch) => {
      try {
        const response = await ApiService.get(`requests${query}`);
        if (response.data) {
          dispatch({
            type: GET_ALL_REQUESTS,
            payload: response.data,
          });
          return;
        }
      } catch (err) {}
    };
  }

  static getExpenditures(id) {
    return async (dispatch) => {
      try {
        const response = await ApiService.get(`requests/${id}`);
        console.log("res", response.data.request);
        if (response.data) {
          dispatch({
            type: GET_ALL_EXPENDITURES,
            payload: response.data,
          });
          return;
        }
      } catch (err) {}
    };
  }
}



// WEBPACK FOOTER //
// ./src/store/actions/organizationmanagement/orgarnization.thunk.js